import React, { useEffect } from 'react'
import { useRouteMatch } from 'react-router'
import { Order as OrderModel, IOrder, useAccountOrders } from 'msp-integrations'
import { Spinner } from 'msp-components'
import OrderActions from './OrderActions/OrderActions'
import OrderStatuses from './OrderStatuses/OrderStatuses'
import OrderDetailHeader from './OrderDetailHeader/OrderDetailHeader'
import OrderShipmentDetails from './OrderShipmentDetails/OrderShipmentDetails'
import OrderProductItemsList from './OrderProductItemsList/OrderProductItemsList'
import OrderTransactionSummary from './OrderTransactionSummary/OrderTransactionSummary'
import * as S from './AccountOrderDetail.styles'

const AccountOrderDetail = () => {
  const { params } = useRouteMatch<{ orderNo: string }>()
  const { ordersById, isLoading, fetchOrder } = useAccountOrders()
  const order = new OrderModel(ordersById[params.orderNo] || ({} as IOrder))

  useEffect(() => {
    fetchOrder(params.orderNo)
  }, [])

  return (
    <div className={S.Wrapper}>
      {isLoading && <Spinner />}
      {!isLoading && (
        <>
          <OrderDetailHeader order={order} />
          <OrderStatuses order={order} />
          <OrderShipmentDetails order={order} />
          <OrderProductItemsList order={order} />
          <OrderTransactionSummary order={order} />
          <OrderActions order={order} />
        </>
      )}
    </div>
  )
}

AccountOrderDetail.getTemplateName = () => 'account-order-history'

export default AccountOrderDetail
